// extracted by mini-css-extract-plugin
export default {"containerFluid":"Team_containerFluid__J1V4k"};